var map = {
	"./Niftycart.jpg": 5814,
	"./Tabletop.jpg": 1393,
	"./Vidash_apna.png": 4283,
	"./alex.jpg": 760,
	"./atx.jpg": 451,
	"./bright_view_care.png": 6776,
	"./bruvi.png": 8832,
	"./bruvi_cloud.png": 7854,
	"./budget_fiscal.png": 5210,
	"./budget_fiscal_overview.png": 4190,
	"./cashflow.png": 3937,
	"./chain_alytics.png": 6103,
	"./collegerasta.png": 5726,
	"./comtech_gold.png": 3068,
	"./doctyme.jpg": 4063,
	"./evebtalog.jpg": 8583,
	"./fleet_management.png": 6874,
	"./hrm.png": 1273,
	"./hyundai_crm.png": 917,
	"./lab.png": 5631,
	"./laundry_management.png": 291,
	"./memo.jpg": 6326,
	"./mersion.png": 3549,
	"./metasociety.png": 6341,
	"./molex.png": 9825,
	"./momy_kidz.png": 6345,
	"./nexus_crm.png": 8838,
	"./order_dashboard.png": 9687,
	"./parsil.jpg": 3967,
	"./petskey.jpg": 5049,
	"./prophero.png": 3483,
	"./sevenwest.jpg": 2112,
	"./shipment_details.png": 3789,
	"./truvo_invoice.png": 4984,
	"./white_clerk.png": 3843,
	"./wisecaller.png": 3298,
	"./yamuna.png": 1855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9471;